"use client"
import { useMediaQuery } from "@react-hooks-library/core";
import Ad from "src/components/ads/Ad";
import withWatchlist from "src/components/filmwebid/withWatchlist";
import NoShows from "src/components/program/NoShows";
import ProgrammedMovie from "src/components/program/ProgrammedMovie";
import { useLocationContext } from "src/lib/contexts/LocationContext";
import { useProgramDatesContext } from "src/lib/contexts/ProgramDatesWrapper";
import styles from './PosterGrid.module.css';
import { ProgramMovie } from "src/lib/types/filminfo/ProgramMovie";
import { format } from "date-fns";

//#region [Props]
type PosterGridProps = {
	movies?: ProgramMovie[];
};
//#endregion


//#region [Component]
export default function PosterGrid({ movies }: PosterGridProps) {
	const isDesktop = useMediaQuery("(min-width: 550px)");
	const locationContext = useLocationContext();
	const { selectedDate } = useProgramDatesContext();

	const datePart =
	selectedDate instanceof Date
		? format(selectedDate, "yyyy-MM-dd")
		: (selectedDate ? String(selectedDate) : "");

	const location = locationContext?.location ?? "";
	const adKey = `${datePart}|${location}`;

	//console.log("[PosterGrid] adKey =", adKey);

	if ((movies?.length ?? 0) === 0 && !locationContext.location) {
		return null;
	}

    return <div className={styles.SProgramContainer}>
        {(movies?.length ?? 0) === 0 && <NoShows className={styles.SNoShows} />}

		{(movies?.length ?? 0) > 0 && <>
			{/** MOBILE */}
                {!isDesktop && <>
                    <WLProgrammedMovie movie={movies![0]} wlcClassName={styles.WLCProgrammedMovie} wlcStyle={{ order: 0 }} />

                    {movies!.length > 2 &&
                        <Ad className={styles.SAd} targetId="FW_topp_program_v2" refreshKey={adKey || ""} removeIfNoAd supportsFixedAd style={{ order: 0 }} />}

				{movies!.length > 1 && <>
                        {movies!.slice(1).map((movie, index) => <WLProgrammedMovie
                            key={`g2_${index}`}
                            movie={movie}
                            wlcStyle={{ order: index + 1 }}
                            wlcClassName={styles.WLCProgrammedMovie}
                        />)}

                        {movies!.length > 8 && <Ad className={styles.SAd} targetId="FW_midt1_program_v2" refreshKey={adKey || ""} style={{ order: 5 }} />}

                        {movies!.length > 13 && <Ad className={styles.SAd} targetId="FW_midt2_program_v2" refreshKey={adKey || ""} style={{ order: 10 }} />}

					{movies!.length > 18 && <Ad className={styles.SAd} targetId="FW_midt3_program_v2" refreshKey={adKey || ""} style={{ order: 15 }} />}
				</>}

				{/** The last ad. NOTE: Keep here to avoid rendering before isDesktop is resolved*/}
                    <Ad className={styles.SAd} targetId="FW_bunn1_program_v2" refreshKey={adKey || ""} style={{ order: movies!.length }} removeIfNoAd supportsFixedAd  />
			</>}

			{/** DESKTOP */}
                {isDesktop && <>
				{movies!.slice(0, 4).map((movie, index) => <WLProgrammedMovie
					key={`g1_${index}`}
					movie={movie}
					wlcStyle={{ order: index }}
				/>)}

                    {movies!.length > 7 && <Ad className={styles.SAd} targetId="FW_topp_program_v2" refreshKey={adKey || ""} style={{ order: 3 }} removeIfNoAd supportsFixedAd  />}

				{movies!.length > 4 && <>
                        {movies!.slice(4).map((movie, index) => <WLProgrammedMovie
                            key={`g2_${index}`}
                            movie={movie}
                            wlcStyle={{ order: index + 4 }}
                        />)}
                        {/** Only show 2nd ad if we have 24 or more movies */}
                        {movies!.length > 23 && <Ad className={styles.SAd} targetId="FW_midt1_program_v2" refreshKey={adKey || ""} style={{ order: 11 }} removeIfNoAd supportsFixedAd  />}
				</>}

				{/** The last ad. NOTE: Keep here to avoid rendering before isDesktop is resolved*/}
                    <Ad className={styles.SAd} targetId="FW_bunn1_program_v2" refreshKey={adKey || ""} style={{ order: movies!.length }} removeIfNoAd supportsFixedAd  />
			</>}
		</>}

    </div>;
}
//#endregion



//#region [Styles]
// Moved to PosterGrid.module.css
//#endregion

const WLProgrammedMovie = withWatchlist(ProgrammedMovie, "movie");
